(function () {
  'use strict';
  function initHero(hero) {
    if (hero.dataset.rcBound) return;
    hero.dataset.rcBound = 'true';
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-rc-slide]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-rc-hero-dot]'));
    if (slides.length < 2) return;
    var index = 0;
    var timer;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === index);
        slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) { dot.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }
    function stop() { window.clearInterval(timer); }
    function start() { if (!reduced) { stop(); timer = window.setInterval(function () { show(index + 1); }, 6500); } }
    hero.querySelector('[data-rc-hero-prev]').addEventListener('click', function () { show(index - 1); start(); });
    hero.querySelector('[data-rc-hero-next]').addEventListener('click', function () { show(index + 1); start(); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { show(i); start(); }); });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    hero.addEventListener('focusout', start);
    start();
  }
  function initTrack(wrapper) {
    if (wrapper.dataset.rcBound) return;
    wrapper.dataset.rcBound = 'true';
    var track = wrapper.querySelector('[data-rc-track]');
    if (!track) return;
    Array.prototype.forEach.call(wrapper.querySelectorAll('[data-rc-scroll]'), function (button) {
      button.addEventListener('click', function () {
        var item = track.firstElementChild;
        if (!item) return;
        var distance = item.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
        track.scrollBy({ left: distance * (button.dataset.rcScroll === 'next' ? 1 : -1), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    });
  }
  function init(context) {
    Array.prototype.forEach.call(context.querySelectorAll('[data-rc-hero]'), initHero);
    Array.prototype.forEach.call(context.querySelectorAll('.rc-carousel, .rc-instagram__wrap'), initTrack);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
}());
